import '../../css/_choose-plan.css';

import { ready } from '../utils/helpers';
import { initFloorPlanTooltip, initFloorPlanZoom } from '../floor-plan-tooltip';
import { initPlanHouseLabels } from '../plan-house-labels';

ready(() => {
  initPlanHouseLabels();
  initFloorPlanTooltip();
  initFloorPlanZoom();
});
